// Idea from https://stackoverflow.com/a/57981688
import { formatDurationAsClock } from 'utils/format_duration'

export default class Timer {
  // timer: element that'll dispatch the timer events
  // timerContainer: element that contains the time itself
  //    set this to null if you only want a countdown without the timer element
  // timeSetInSeconds: number on how long the timer have in seconds
  constructor(timer, timerContainer, timeSetInSeconds) {
    this.timer = timer
    this.timerContainer = timerContainer
    this.totalMilliseconds = timeSetInSeconds * 1000
    this.timeRemaining = this.totalMilliseconds
    this.startTime = Date.now() + this.timeRemaining
    this.isRunning = false
  }

  init() {
    if (!this.isRunning) {
      this.start()
    }

    const intervalID = setInterval(() => {
      const time = this.getTime()
      this._setTimerContainer(time)

      if (this.isFinished(time)) {
        this.timer.dispatchEvent(new CustomEvent("timer.finish"))
        this.isRunning = false
        clearInterval(intervalID)
      }
    }, 100)
  }

  start() {
    if (this.isRunning) {
      return console.error("Timer is already running")
    }

    this.isRunning = true
    this.startTime = Date.now()
  }

  pause() {
    if (!this.isRunning) {
      return console.error("Timer is already paused")
    }

    this.isRunning = false
    this.timeRemaining = this.timeRemaining - this._getTimeElapsedSinceLastStart()
  }

  stop() {
    this.isRunning = false
    this.timeRemaining = this.totalMilliseconds
    this.startTime = Date.now() + this.timeRemaining

    this._setTimerContainer(this.getTime())
  }

  getTime() {
    if (this.isRunning) {
      const timeCalc = Math.round((this.timeRemaining - this._getTimeElapsedSinceLastStart()) / 1000)

      return this._checkAndReturnTimeGreaterThanZero(timeCalc)
    }

    return this._checkAndReturnTimeGreaterThanZero(Math.round(this.timeRemaining / 1000))
  }

  isFinished(time) {
    return time <= 0
  }

  _checkAndReturnTimeGreaterThanZero(time) {
    if (time <= 0) {
      return 0
    }

    return time
  }

  _getTimeElapsedSinceLastStart () {
    if (!this.startTime) {
      return 0
    }

    // https://stackoverflow.com/a/29972322 we need to use Date.now() vs subtracting a second per tick to
    // deal with time drifting leading to inaccuracies
    return Date.now() - this.startTime
  }

  _setTimerContainer(time) {
    if (this.timerContainer !== null) {
      this.timerContainer.innerText = formatDurationAsClock(time)
    }
  }
}
